import { cn } from "web-design-system";

export function WizardProgressBar({
  currentStep,
  totalSteps,
}: {
  currentStep: number;
  totalSteps: number;
}) {
  return (
    <div className="flex shrink-0 gap-2">
      {Array.from({ length: totalSteps }).map((_, index) => (
        <div
          key={index}
          className={cn(
            "h-1 flex-1 rounded-full",
            index <= currentStep ? "bg-foreground" : "bg-muted"
          )}
        />
      ))}
    </div>
  );
}
